import { useActualAmounts } from '@/features/shiftCloseouts/form'
import { DailyShiftCloseout, ShiftCloseoutReconciliation } from '@/features/shiftCloseouts/types'
import { calculateReconciliation } from '@/features/shiftCloseouts/utils/calculateReconciliation'

export const useShiftCloseoutReconciliation = ({
    paymentMethods,
    preview,
}: DailyShiftCloseout): ShiftCloseoutReconciliation => {
    const actualAmounts = useActualAmounts()

    return calculateReconciliation(preview.currency, paymentMethods, actualAmounts)
}
